import { useUser, RedirectToSignIn, useOrganization } from "@clerk/clerk-react"
import {
  Center,
  Container,
  Image,
  LoadingOverlay,
  Paper,
  Stack,
  Text,
  Title,
} from "@mantine/core"
import { Navigate, useLocation } from "react-router-dom"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { useBrand } from "@costory/front/lib/whitelabel"
import { useSetupQuery } from "@costory/front/queries/setup"

export const AuthGuardWithoutOrganizationSetupDomain = () => {
  const { isLoaded, isSignedIn, user } = useUser()
  const { organization } = useOrganization()
  const brand = useBrand()

  const location = useLocation()
  const redirectUrl = encodeURI(location.pathname + location.search)
  const emailAddress =
    user?.primaryEmailAddress?.emailAddress ||
    user?.emailAddresses?.[0]?.emailAddress ||
    "your email"

  const query = useSetupQuery({
    isAws: false,
    isAzure: false,
    isGcp: false,
    isDatadog: false,
  })

  if (!isLoaded) return <LoadingOverlay visible />
  if (!isSignedIn) return <RedirectToSignIn redirectUrl={redirectUrl} />
  if (organization) return <Navigate to="/home" />

  return (
    <Center mih="100vh" bg="surfaceGround">
      <Container size="xs">
        <QueryWrapper query={query} allowEmptyArray allowNull>
          {() => (
            <Stack align="center" gap="xl">
              <Paper
                w={120}
                h={120}
                radius="lg"
                bg="surfaceCard"
                shadow="sm"
                display="flex"
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Image
                  src={brand.authLogo}
                  h={80}
                  w="auto"
                  alt={`${brand.name} logo`}
                  fit="contain"
                />
              </Paper>

              <Stack align="center" gap="xs">
                <Title order={2} fw={600} size="h1">
                  Ready in just a moment!
                </Title>
                <Text c="textSecondary" size="md" ta="center">
                  We&apos;re setting up your platform. You&apos;ll receive a
                  sign in link at {emailAddress} within one business day
                </Text>
              </Stack>
            </Stack>
          )}
        </QueryWrapper>
      </Container>
    </Center>
  )
}
